module.exports = __webpack_public_path__ + "static/img/crm_body_left_2.44732361.png";